import React, { useState } from "react";
import {  Menu, ListItemText, ListItemIcon, MenuItem, Button } from '@mui/material';
import { Accept } from 'react-dropzone';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import SummarizeIcon from '@mui/icons-material/Summarize';

type ImportButtonProps = {
  onImport: (accept: Accept) => void 
}

const ImportButtons = (props: ImportButtonProps) => {

  const [showsOptions, showOptions] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  const onImport = (accept: Accept) => {
    props.onImport(accept);
    showOptions(false);
  }

  return <>
    <Button size="small" 
            color="secondary" 
            sx={{mr: '1rem'}} 
            onClick={e => {
              setAnchorEl(e.currentTarget);
              showOptions(true);
            }}>
      <UploadFileIcon color="primary" />
    </Button>

    <Menu
      anchorEl={anchorEl}
      open={showsOptions}
      onClose={() => showOptions(false)}
    >
      <MenuItem onClick={() => onImport({ 'application/pdf': ['.pdf'] })}>
        <ListItemIcon>
          <PictureAsPdfIcon />
        </ListItemIcon>
        <ListItemText>
          Import PDF file
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => onImport({ 'application/vnd.ms-excel': ['.xlsx'] })}>
        <ListItemIcon>
          <PivotTableChartIcon />
        </ListItemIcon>
        <ListItemText>
          Import Excel file
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => onImport({ 'text/csv': ['.csv'] })}>
        <ListItemIcon>
          <TextSnippetIcon />
        </ListItemIcon>
        <ListItemText>
          Import CSV file
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => onImport({ 'text/html': ['.html'] })}>
        <ListItemIcon>
          <SummarizeIcon />
        </ListItemIcon>
        <ListItemText>
          Import MS Whiteboard file
        </ListItemText>
      </MenuItem>
    </Menu>
  </>
}

export default ImportButtons;